import React from "react";
import { KitCardWrapper, KitDescription } from "../KitCard/KitCard";
import Grid from "../Grid";
import Flex from "../Flex";
import ImageView from "../ImageView";
import Box from "../Box";
import Text from "../Text";

type Props = {
  onClick?: (e: React.MouseEvent) => void;
};

const EmptyKitCard: React.FC<Props> = ({ onClick }) => {
  return (
    <KitCardWrapper
      onClick={onClick}
      width="100%"
      shadowOnHover={true}
      border="default"
      p="16px"
      borderRadius="medium">
      <Grid width="100%" templateColumns="minmax(auto, 144px) minmax(200px, 4fr)" gap="12px">
        <Flex alignItems="flex-start">
          <ImageView
            src={null}
            icon={"action.add"}
            alt={"Create a kit"}
            aspectRatio={63}
            cover
            width="100%"
            background={"grayLightest"}
            borderRadius="small"
          />
        </Flex>
        <Flex width="100%" flexDirection="column" overflow="hidden" gap={"4px"}>
          <Flex justifyContent="space-between" gap="16px" width="100%">
            <Flex flexDirection="column" gap="16px">
              <Box>
                <Text as="h1" font="ui.regularBold" truncate onClick={onClick}>
                  {"Create a new kit"}
                </Text>
              </Box>
            </Flex>
          </Flex>
          <KitDescription maxWidth={"480px"} font="ui.small" color="grayDarker">
            Kits are where your assets and brand guidelines are housed. Start here if you’re setting
            up a new Lingo space.
          </KitDescription>
        </Flex>
      </Grid>
    </KitCardWrapper>
  );
};

export default EmptyKitCard;
